module.exports = __webpack_public_path__ + "02_short_black.ed9880c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/02_short_black.png
// module id = RIYy
// module chunks = 0